import { isEmpty, isNumber, map } from 'lodash';
import React, { useMemo } from 'react';
import useProgramGroupSelector from '../../../data/hooks/useProgramGroupSelector';
import useT from '../../utils/Translations/useT';
import { RETURN_TYPE } from '../base/SelectBox';
import useResetOnDeps from './hooks/useResetOnDeps';
import MultiselectFilter from './MultiselectFilter';
import SelectBoxFilter from './SelectBoxFilter';
import { Active, Inactive, Deleted } from '../../../../model/Statuses';
const ProgramGroupSelector = ({ value, onChange, orgGroupId, organisations, isSingleSelect = false, ...rest }) => {
    const t = useT();
    const { models, loading } = useProgramGroupSelector({
        orgGroupId,
        organisations,
        programsStatuses: [Active.value, Inactive.value, Deleted.value],
        skip: isEmpty(organisations),
    });
    const modelsIds = useMemo(() => (isSingleSelect ? [] : map(models, 'id')), [
        isSingleSelect,
        models,
    ]);
    const title = useMemo(() => t('Program Group'), [t]);
    const isDisabled = useMemo(() => !isNumber(orgGroupId) || loading || isEmpty(organisations), [orgGroupId, loading, organisations]);
    const defaultValue = useMemo(() => {
        if (value)
            return value;
        if (isSingleSelect) {
            return '';
        }
        if (isDisabled) {
            return [];
        }
        return modelsIds;
    }, [isDisabled, isSingleSelect, modelsIds, value]);
    useResetOnDeps({ orgGroupId, loading, isDisabled }, onChange, defaultValue);
    return isSingleSelect ? (<SelectBoxFilter disabled={isDisabled} itemValuePropName="id" options={models} returnType={RETURN_TYPE.OPTION} title={title} value={value} onChange={onChange} {...rest}/>) : (<MultiselectFilter isEmptyAllowed showSelectAll showStatus disabled={isDisabled} options={models} title={title} value={value} onChange={onChange} {...rest}/>);
};
export default ProgramGroupSelector;
